import {
  FetchResponseError,
  addMessageToExsistingFetchError,
} from 'utils/errors/customError';
import { buildPath, httpGet } from 'utils/http';

import { FormidlingskanalDto } from './dto';
import {
  FormidlingskanalService,
  GetFormidlingskanal,
  GetFormidlingskanalById,
} from './interface';

const basePath = 'formidlingskanal';

const getFormidlingskanal: GetFormidlingskanal = async (signal?) => {
  const fullPath = buildPath(`${basePath}`);
  try {
    return await httpGet<FormidlingskanalDto[]>(fullPath, signal);
  } catch (error) {
    throw addMessageToExsistingFetchError(
      error as FetchResponseError,
      `Henting av formidlingskanaler feilet`
    );
  }
};

const getFormidlingskanalById: GetFormidlingskanalById = async (
  id,
  signal?
) => {
  const fullPath = buildPath(`${basePath}/${id}`);
  try {
    return await httpGet<FormidlingskanalDto>(fullPath, signal);
  } catch (error) {
    throw addMessageToExsistingFetchError(
      error as FetchResponseError,
      `Henting av formidlingskanal for id ${id} feilet`
    );
  }
};

export default {
  getFormidlingskanalById,
  getFormidlingskanal,
} as FormidlingskanalService;
